<template>
  <div>
    <div>
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <div>
      <v-data-table
        :headers="headers"
        :items="rwluarnegeris"
        :items-per-page="-1"
        :mobile-breakpoint="0"
        :loading="ldata"
        hide-default-footer
        style="text-overflow: ellipsis; white-space: nowrap"
      >
        <template v-slot:top>
          <rwluarnegeriModalEdit />
          <rwluarnegeriModalHapus />
        </template>
        <template v-slot:[`item.negara`]="{ item }">
          {{ item.negara }} <br />
          {{ item.waktu.mulai }} S/d {{ item.waktu.selesai }}
        </template>
        <template v-slot:[`item.tujuan`]="{ item }">
          {{ item.tujuan }} <br />
          {{ item.sumberBiaya }}
        </template>
        <template v-slot:[`item.sk`]="{ item }">
          Pejabat : {{ item.suratKeputusan.pejabat }} <br />
          Nomor : {{ item.suratKeputusan.nomor }} <br />
          Tanggal : {{ item.suratKeputusan.tanggal }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-1" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import rwluarnegeriModalEdit from "@/components/asn/profil/rwluarnegeri/ModalEdit";
import rwluarnegeriModalHapus from "@/components/asn/profil/rwluarnegeri/ModalHapus";

import modal_editState from "@/store/asn/rwluarnegeri/modal_edit";
import modal_hapusState from "@/store/asn/rwluarnegeri/modal_hapus";
import refreshView from "@/store/asn/rwluarnegeri/viewRwluarnegeri";

export default {
  name: "rwluarnegeri",

  components: {
    rwluarnegeriModalEdit,
    rwluarnegeriModalHapus,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    alertMassage: {
      get() {
        return refreshView.state.alertMassage;
      },
    },

    success: {
      get() {
        return refreshView.state.success;
      },

      set(value) {
        refreshView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return refreshView.state.alertBerhasil;
      },

      set(value) {
        refreshView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return refreshView.state.alertGagal;
      },

      set(value) {
        refreshView.commit("gagalAlert", value);
      },
    },
  },

  watch: {
    refresh() {
      this.getData();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  data: () => ({
    token: Cookie.get("token"),
    rwluarnegeris: [],

    ldata: true,

    //Kebutuhan Edit
    editedIndex: -1,
    hapusIndex: -1,

    headers: [
      {
        text: "Negara Tujuan / Mulai S/d Berakhir",
        align: "start",
        value: "negara",
      },
      { text: "Tujuan Kunjungan / Sumber Biaya", value: "tujuan" },
      { text: "Surat Keputusan (SK)", value: "sk" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        align: "center",
        width: "80px",
      },
    ],
  }),

  async mounted() {
    this.get_nip = this.$route.params.id;
    this.getData();
  },

  methods: {
    getData() {
      this.ldata = true;
      const url = process.env.VUE_APP_ASN + "luarnegeri/nip/" + this.get_nip;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.ldata = false;
          refreshView.commit("refreshData", false);
          this.rwluarnegeris = response.data.mapData.RwLuarNegeri;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    editItem(item) {
      this.editedIndex = this.rwluarnegeris.indexOf(item);
      this.rwluarnegeri = Object.assign({}, item);
      modal_editState.commit("toggleModal", true);
      modal_editState.commit("editModal", Object.assign({}, item));
    },

    deleteItem(item) {
      this.hapusIndex = this.rwluarnegeris.indexOf(item);
      this.rwluarnegeri = Object.assign({}, item);
      modal_hapusState.commit("toggleModal", true);
      modal_hapusState.commit("hapusModal", Object.assign({}, item));
    },
  },
};
</script>
